import { get } from 'lodash';
import { MerchantData } from './types';
import { AppState } from '../rootReducer';

export const getMerchants = (state: AppState): MerchantData[] => get(state, 'supportSearch.merchants', []);
export const getTutorialScreenState = (state: AppState): boolean => get(state, 'supportSearch.showTutorialScreen');
